/// <reference types="vite/client" />
import { Documents } from 'merchant-api/types';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface useDocumentsProps {
  isLoading: boolean;
  documents: Documents[] | undefined;
  isError: any;
  query: UseQueryResult<Documents[]>;
}

const getDocuments = () =>
  spiceroad.get<Documents[]>('/v1/documents').then((res) => res.data);

export const getDocumentsOpts = queryOptions<Documents[]>({
  queryKey: ['documents'],
  queryFn: getDocuments,
  throwOnError: false,
  retry: 0,
});

export function useDocuments(): useDocumentsProps {
  const query = useQuery(getDocumentsOpts);
  const { data, error, isLoading } = query;

  return {
    documents: data,
    isLoading,
    isError: error,
    query,
  };
}

export default useDocuments;
